import React from "react";
import Subtitle from "../../../../components/Subtitle";
import CardFull from "../card/full";
import styles from "./beneficios.module.css";
import SliderBeneficios from "./slider";

const Beneficios = ({ beneficios }) => {
    return (
        <React.Fragment>
            {beneficios !== undefined && beneficios !== null && beneficios.length > 0
                ? <div className={styles.container__full}>
                    <CardFull>
                        <Subtitle sname="Beneficios adicionales" mostrar="true" />
                        <div className={styles.container__wrapper}>
                            <div className={styles.descripCard}></div>
                            {/* CARDS BENEFICIOS */}
                            <SliderBeneficios data={beneficios} />
                        </div>
                    </CardFull>
                </div>
                : null
            }
        </React.Fragment>
    )
}

export default Beneficios;